/**
 * Usage:
 * import { hideElement } from '@local_modules/generic/dom/hide-element.js'
 *
 * @param {String} elementId
 * @returns {Element|null} DOM Element or null
 */
export function hideElement (elementId) {
  const element = document.getElementById(elementId)
  if (!element) return null

  element.classList.add('is-hidden')
  return element
}
